import ReactInputMask from "react-input-mask";
import {useEffect, useState} from "react";
import {useForceUpdate} from "../../services/misc.functions";
import {callChangePhone, callLoginApi} from "../../services/auth.service";
import {env} from "../../constants/global.vars";
import {ApiService} from "../../lib/http.service";
import {auth} from "../../store/auth.store";

export function MobileValidationModal(prop: any) {

    const [showChangePhone, setShowChangePhone] = useState<any>(false);
    const [errorText, setErrorText] = useState<any>(null);

    const result = prop.result;
    const username = prop.username;
    const password = prop.password;

    async function validateMobile() {
        auth.userValidation = false;
        const api = new ApiService();
        let mobile_validation_code: any = document.getElementById("id_mobileValidationCode");

        var payload = {
            mobile: result?.data?.mobile,
            code: mobile_validation_code.value.replaceAll(' ', ''),
        };

        try {
            const response: any = await api.start("post", env.api + "/member/api/mobile_validation/", payload, false);
            if (response.status) {
                callLoginApi(username, password, {validation_token: response.data.validation_token});
            } else {
                setErrorText(response.message);
            }
        } catch (e: any) {
            throw e;
        }
    }


    return (<>
        <div className="p-1">
            {result.data?.verify_message &&
                <p className="py-3 alert alert-danger text-center">{result?.data?.verify_message}</p>}

            {!showChangePhone && <div className={"pt-4 mb-4 pb-1"}>
                <p className="text-md  text-center">
                    Telefon numaranızı doğrulamalısınız, doğrulanmış bir telefon numaranız olmadan
                    sisteme giriş yapamazsınız. Size yeni bir doğrulama kodu gönderdik.
                    <br/><br/>Sisteme kayıtlı numaranız {result?.data?.mobile} şeklindedir, eğer doğrulama sms'i
                    almadıysanız,
                    numaranızı güncelleyebilirsiniz. <a href="#" onClick={() => {
                    setShowChangePhone(true);
                }} className="text-md text-primary text-bold">Cep Telefon Numaranızı Güncelleyin</a>
                </p>

            </div>}
            {showChangePhone && <> Telefon numaranızı giriniz, doğrulanmış bir telefon numaranız olmadan sisteme giriş
                yapamazsınız. Yeni girdiğiniz numaraya bir doğrulama kodu gönderilecektir. <br/><br/>Sisteme kayıtlı
                numaranız {result?.data?.mobile} şeklindedir </>}
            {!showChangePhone && <div className="row py-3 ">
                <div className="col-12">
                    <form>
                        <ReactInputMask
                            mask="9 9 9 9 9 9"
                            className="form-control password-code-input  w-100"
                            placeholder={"_ _ _ _ _ _"}
                            id="id_mobileValidationCode"
                        />
                        {errorText && <p className="my-2 text-danger">{errorText}</p>}
                    </form>
                </div>
                <div className="col-12">
                    <ResendValidationButton resendTimer={(180000)} username={username}
                                            password={password}></ResendValidationButton>
                </div>

            </div>}
            {showChangePhone && <div className="row py-3">
                <div className="col-12">
                    <form>
                        <ReactInputMask
                            mask="599 999 99 99"
                            className="form-control"
                            placeholder={"5XXX XXX XX XX"}
                            id="id_newMobile"
                        />
                    </form>

                </div>
            </div>}
            {!showChangePhone && <button className={"button sm secondary filled mt-3 w-100 text-bolder mx-1"} onClick={() => {
                validateMobile();
            }}>
                Numaramı Doğrula
            </button>}
            {showChangePhone && <button className={"button sm secondary filled mt-3 w-100 text-bolder mx-1"} onClick={() => {
                let mobile_change: any = document.getElementById("id_newMobile")
                callChangePhone(username, password, mobile_change.value);
            }}>
                Numaramı Değiştir
            </button>}
        </div>
    </>)
}

let resendTimer: any = null;
let timer: any = null;

export function ResendValidationButton(prop: any) {

    const [resendTimerButton, setResendTimerButton] = useState<any>(false);

    if (resendTimer === null) {
        resendTimer = Number(prop.resendTimer);
    }

    const forceUpdate = useForceUpdate();
    useEffect(() => {

        if (!resendTimerButton) {
            let timer = setTimeout(() => {
                resendTimer = resendTimer - 1000;
                if (resendTimer <= 0) {
                    setResendTimerButton(true);
                    clearTimeout(timer);
                }
                forceUpdate();
            }, 1000);
        }


        return () => {
            clearTimeout(timer)
        }
    }, [resendTimer]);

    return <>
        <button disabled={!resendTimerButton} onClick={() => {
            callLoginApi(prop.username, prop.password)
            resendTimer = Number(prop.resendTimer);
            setResendTimerButton(false);
            forceUpdate();
        }} className="button tertiary filled w-100 mt-2">Tekrar Gönder {resendTimer > 0 &&
            <span>({Math.floor(resendTimer / 60000) + ":" + ("00" + ((resendTimer / 1000) % 60)).slice(-2)})</span>}</button>
    </>

}

